import React, { Suspense, useRef } from 'react';
import Layout from './components/layout/Layout';
import HeroSection from './components/sections/HeroSection';
import { ContactModalProvider } from './contexts/ContactModalContext';
import WhatsAppFloat from './WhatsAppFloat';

// Lazy load das seções
const CustomerGallery = React.lazy(() => import('./components/sections/CustomerGallery'));
const ConsoleShowcase = React.lazy(() => import('./components/sections/ConsoleShowcase'));
const TradeProcess = React.lazy(() => import('./components/sections/TradeProcess'));
const UnboxingSection = React.lazy(() => import('./components/sections/UnboxingSection'));
const Faq = React.lazy(() => import('./components/sections/Faq'));

function App() {
  const consoleRef = useRef(null);

  React.useEffect(() => {
    // Carregar o Font Awesome dinamicamente
    const script = document.createElement('script');
    script.src = 'https://kit.fontawesome.com/a076d05399.js';
    script.crossOrigin = 'anonymous';
    document.body.appendChild(script);
    return () => {
      if (script.parentNode) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <ContactModalProvider>
      <Layout>
        <HeroSection consoleRef={consoleRef} />
        <Suspense fallback={<div style={{minHeight: 200, textAlign: 'center'}}>Carregando seções...</div>}>
          <CustomerGallery />
          <TradeProcess />
          <ConsoleShowcase ref={consoleRef} />
          <UnboxingSection />
          <Faq />
        </Suspense>
      </Layout>
      <WhatsAppFloat />
    </ContactModalProvider>
  );
}

export default App;
